package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class MedicalRecordSignSymptomCharacteristicState(private val literal: String) : IEnumType {
	是("是"),
	否("否");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "medical_record_sign_symptom_characteristic_state"}
	override fun getLiteral(): String {return literal}
}
